import type { RuleHeaderModel } from '@shared/components/rules-components/accordion-header/rule-header-accordion.component';

import type { Node } from '../../pages/new-rules/chips-page.models';

export const NEW_RULE_DRAFT_KEY = 'new-rules-draft-v1';

export interface NewRuleDraftState {
  ruleId?: string | null;
  header: RuleHeaderModel | null;
  nodesMain: Node[];
  nodesWriteoff: Node[];
  openIds: number[];
}
